import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgxMasonryOptions } from 'ngx-masonry';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';

@Component({
    selector: 'app-noticias',
    templateUrl: './noticias.component.html',
    standalone: false
})
export class NoticiasComponent implements OnInit{

  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  content_name: string = 'linhas-news-list'

  news_content: string = 'linhas-noticia';
  newsInfo: any = {};


  masonryOptions: NgxMasonryOptions = {
    gutter: 20,
    itemSelector: '.masonry-item',
    percentPosition: true,
  };

  newsReady: number = 0;

  newsList: any[] = []
  newsListSize: number = 0;
  newsListPage: number = 1;
  newsMaxItems: number = 50;

  constructor(
    private cmsService: CmsService,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['noticias']
      this.title.setTitle(pageTitle);
    })
  }

    ngOnInit() {
      this.getNews()
      this.getContent();
    }

  getContent(){
    this.cmsService.getContentList(this.news_content, this.language).subscribe(
      {
        next: data => {
          this.newsInfo = data['body']['data'];

        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

    getNews(){
      this.newsReady = 0;
      this.newsList = [];
      this.cmsService.getContentList(this.content_name, this.language).subscribe(
        {
          next: data => {
            this.newsList = data['body']['data'];

            this.newsList.forEach(element => {
              let date = new Date(element.Data)
              element.formattedDate = Intl.DateTimeFormat(this.language, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
            });

            this.newsList.sort((a,b) => (a.Data > b.Data) ? -1 : 1 );

            this.newsListSize = this.newsList.length;

            this.newsReady = 1;

          },
          error: er => {
            this.router.navigate(['/500']);
          }
        }
      );
    }

    goToNews(id: string){
      this.router.navigate(['/noticias-detalhe'], { queryParams: { id: id } });
    }
}
